// src/components/Home.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Container, Row, Col, Card, Accordion } from "react-bootstrap";
import {
  FaGooglePlay,
  FaAppStore,
  FaRocket,
  FaInfoCircle,
  FaLightbulb,
  FaQuestionCircle,
} from "react-icons/fa";
import SaveTrees from "./SaveTree";

const Home = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate("/collaborate");
  };
  return (
    <div>
      {/* Replace Jumbotron with a Container and style it */}
      <Container
        fluid
        className="hero-section justify-content-center py-4"
      >
        <Row className="align-items-center">
          {/* Left Section - Text and Buttons */}
          <Col xs={12} md={7} className="text-center text-md-start px-4">
            <h1 className="mb-3">
              Store and organize all your receipts in one place, accessible from
              anywhere. No more paper clutter!
            </h1>
            <p className="mb-4">Manage Your Receipts Effortlessly.</p>
            {/* Buttons Section */}
            <div className="d-flex flex-column flex-md-row gap-3">
              <Button
                variant="success"
                size="lg"
                className="d-flex align-items-center justify-content-center"
                onClick={handleGetStarted}
              >
                <FaRocket size={25} />
                <span className="ms-3">Collaborate with us</span>
              </Button>
              <Button
                variant="warning"
                size="lg"
                href="https://play.google.com/store"
                target="_blank"
                className="d-flex align-items-center justify-content-center"
              >
                <FaGooglePlay size={30} />
                <span className="ms-3">Google Play</span>
              </Button>
              <Button
                variant="light"
                size="lg"
                href="https://www.apple.com/app-store/"
                target="_blank"
                className="d-flex align-items-center justify-content-center"
              >
                <FaAppStore size={30} />
                <span className="ms-3">App Store</span>
              </Button>
            </div>
          </Col>

          {/* Right Section - Image */}
          <Col
            xs={12}
            sm={8}
            md={6}
            lg={4}
            className="text-center mt-5 mt-md-0"
          >
            <img
              src="Landing2.png"
              className="img-fluid"
              alt="Hero Illustration"
              style={{ maxHeight: "50vh", objectFit: "contain" }}
            />
          </Col>
        </Row>
      </Container>
      {/* Optional: Add more content here */}
      <Container>
        <Row>
          <Col md={4}>
            <Card className="card-border-animation" style={{ border: '2px solid  #007bff', borderRadius: '8px' }}>
              <Card.Body className="text-center">
                <Card.Title>
                  <FaQuestionCircle size={30} color="#007bff" /> Why{" "}
                </Card.Title>
                <Card.Text>
                  E-receipt is an electronic receipt hub that offers a
                  cost-effective, environmentally friendly, and convenient
                  alternative to paper receipts, enhancing customer experience,
                  simplifying expense tracking, reducing waste, and providing
                  businesses with opportunities for analytics, marketing, and
                  operational efficiency.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="advantage-card" style={{ border: '2px solid #007bff', borderRadius: '8px' }}>
              <Card.Body className="text-center">
                <Card.Title>
                  <FaInfoCircle size={30} color="#28a745" /> What{" "}
                </Card.Title>
                <Card.Text>
                  E-receipt is a virtual platform which gives a digital versions
                  of traditional receipts provided electronically rather than on
                  paper. They are typically delivered via Email, SMS, Mobile
                  App. We are widely used to enhance customer convenience,
                  support sustainability, improved efficiency and streamline
                  business operations.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="advantage-card" style={{ border: '2px solid #007bff', borderRadius: '8px' }}>
              <Card.Body className="text-center">
                <Card.Title>
                  <FaLightbulb size={30} color="#ffc107" /> How{" "}
                </Card.Title>
                <Card.Text>
                  E-receipt works by generating a digital version of a purchase
                  receipt at the point of sale, which is securely delivered to
                  the customer via email, SMS, or an app, and stored in a cloud
                  system for easy access and management. We Offer centralized
                  storage and easy management for users. This process eliminates
                  the need for paper receipts.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <Container fluid className="hero-section1 text-center py-5">
        <span className="highlight-text">
          Say <i>"hello"</i> to E-RECEIPT
        </span>
        <Row>
          <Col xs={12} sm={8} md={6} lg={4}>
            <img src="Landing3.png" className="img-fluid" alt="" />
          </Col>
          <Col>
            <span>
              <br />
            </span>
            <Accordion defaultActiveKey="0" flush>
              <Accordion.Item eventKey="0">
                <Accordion.Header>For Business</Accordion.Header>
                <Accordion.Body>
                  E-receipt works by generating a digital version of a purchase
                  receipt at the point of sale, which is securely delivered to
                  the customer via email, SMS, or an app, and stored in a cloud
                  system for easy access and management. We Offer centralized
                  storage and easy management for users. This process eliminates
                  the need for paper receipts.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>For User</Accordion.Header>
                <Accordion.Body>
                  E-Receipt application aims to provide a seamless solution for
                  users to receive, store, and manage digital receipts. The
                  application focuses on reducing paper waste, improving
                  organizational efficiency, and enabling users to track their
                  expenses easily.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>Environmental Benefits</Accordion.Header>
                <Accordion.Body>
                  E-Receipts eliminate the need for paper, reducing waste and
                  the carbon footprint associated with printing and disposing of
                  paper receipts. This supports sustainability efforts and helps
                  conserve natural resources.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  Convenience and Accessibility
                </Accordion.Header>
                <Accordion.Body>
                  With the rise of digital transactions and the widespread use
                  of smartphones, e-receipts offer a convenient way to store
                  proof of purchase. Consumers no longer need to keep track of
                  physical receipts, which can be easily lost or damaged.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header>Faster Transactions</Accordion.Header>
                <Accordion.Body>
                  E-receipts streamline the transaction process, especially in
                  businesses where large volumes of customers are served.
                  Customers can receive receipts instantly via email or text,
                  eliminating the need to print them out.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>
      </Container>
      <Container>
        <SaveTrees />
      </Container>
    </div >
  );
};

export default Home;
